import FavouriteSelected from '@sfly/uig-svg-icon/action/favorite_selected';

const LikeAlreadyIcon = () => {
    return (<div className="likeIcon">
        <FavouriteSelected/>
    </div>)
}

export default LikeAlreadyIcon;